import { Col, Flex, Row } from 'antd'

/**
 * returns JSX for viewing and editing teams
 */
function PlayerManagement() {
  return (
    <>
      {/* navigation */}
      <Flex vertical gap="20px">
        <Row gutter={10} className="main-navigation">
          <Col>
            <Flex
              gap="10px"
              className="main-navigation__heading"
              align="center"
            >
              <h3>Player Management</h3>
            </Flex>
          </Col>
        </Row>
      </Flex>
    </>
  )
}

export default PlayerManagement
